// Falha de um ato do delegation log: o 423 das travas lista TODOS os motivos (`DelegationBlockedReasons`); qualquer outro erro vai ao `ProblemAlert` padrão
// (409 de estado/conteúdo, 422 de papel/forma, 401/403, rede). O diálogo que a exibe permanece aberto.
import { ProblemAlert } from '../../../../components';
import { blockedReasonsOf } from '../delegationModel';
import { DelegationBlockedReasons } from './DelegationBlockedReasons';

export interface DelegationFailureProps {
  readonly error: unknown;
  readonly taskNames?: ReadonlyMap<string, string> | undefined;
}

export function DelegationFailure({ error, taskNames }: DelegationFailureProps) {
  if (error === null || error === undefined) {
    return null;
  }
  const reasons = blockedReasonsOf(error);
  return reasons ? (
    <DelegationBlockedReasons reasons={reasons} taskNames={taskNames} />
  ) : (
    <ProblemAlert error={error} />
  );
}
